import { Component, Vue } from 'vue-property-decorator'
import { getCustomerConversionFollowListByCustomerConversionId }  from '@/api/customer'
import {getMessageReviewById, setMessageReviewUserByMessageReviewId} from "@/api/message";

@Component({})
export default class FollowRecord extends Vue {
    tableData = []
    page = 1
    limit = 20
    total = 0
    id: number;
    loading = false
    // fsnumShow = true
    addSignShow = false
    transferShow = false
    approvedVisible = false // 审批通过
    approvedData = {}
    isAgreeRevoke = '' // 审批通过是否允许提交人撤回
    disBtn = false
    types = ''
    status = null
    approvalVisible = false
    nodeType: string = null //驳回到哪个节点
    stepNode = {
        isFirstNode: false,
        isSyncEkuaibao: false,
        isSyncEqianbao: false,
    }
    logData = []
    isMessageReviewId = ''
    infoData: any = ''
    shenpiStatus: any = ''
    opinion = ''
    opinionDialog = false
    type = ''
    culesInfoShow = false
    customerInfoShow = true
    pageLoading = false
    isNotReject = false

    created() {
        this.status = Number(this.$route.query.status)
        this.types = this.$route.query.types ? this.$route.query.types as string : ''
        this.id = Number(this.$route.query.approval_id)
        this.type = this.$route.query.type as string
        this.getData()
    }
    async getData() {
        this.pageLoading = true
        await getMessageReviewById(this.id,this.types).then((data: any)=>{
        this.infoData = data.result
        this.tableData = data.result.customerConversionFollowList
        this.isNotReject = data.result.isNotReject == true ? false : true
        this.logData = data.result.messageReviewLogList
        this.isMessageReviewId = data.result.id

        this.stepNode.isFirstNode = this.infoData.isFirstNode
        this.stepNode.isSyncEkuaibao = this.infoData.isSyncEkuaibao
        this.stepNode.isSyncEqianbao = this.infoData.isSyncEqianbao
        this.pageLoading = false
        }).catch(err=>{
            this.pageLoading = false
        })
    }



    onOpen(url: string) {
        window.open(url, '_blank')
    }


    // 驳回审批
    clickRejectButton(status: number) {
        this.shenpiStatus = 2
        this.approvalVisible = true
    }

    //     关闭审批弹框
    handleApprovalClose() {
        this.approvalVisible = false
    }

//    驳回弹框确认
    doApprovalConfirm(data) {
        this.nodeType = data.rejectNode
        this.opinion = data.reviewIdea
        this.approvalVisible = false
        this.confirmDialog()
    }

    // 审批通过弹框取消
    handleApprovedClose(){
        this.approvedVisible = false
    }

    /*
  * 关闭转交弹框*/
    closeTransfer() {
        this.transferShow = false
    }

    /*
    * 转交弹框确认*/
    confirmTransfer() {
        this.transferShow = false
    }

    /*
    * 关闭加签*/
    closeAddSign() {
        this.addSignShow = false
    }

    /*
    * 确认加签*/
    confirmAddSign() {
        this.addSignShow = false
    }

    /*
    * */
    // 审批通过弹框确认
    doApprovedConfirm(data) {
        this.opinion = data.reviewIdea
        this.isAgreeRevoke = data.isAgreeRevoke
        this.approvedVisible = false
        this.approvedConfirm()
    }

    /*
    * 通过*/
    // 通过
    approvedConfirm() {

        const newObj: any = {}

        const obj = {
            messageReviewId: this.id,
            status: this.shenpiStatus,
            opinion: this.opinion,
            form: this.shenpiStatus === 2 ? {} : newObj,
            isRevoke: this.isAgreeRevoke
        }
        for (const key in obj) {
            if (!obj[key] || obj[key].length === 0) {
                delete obj[key]
            }
        }

        this.disBtn = true
        setMessageReviewUserByMessageReviewId(obj).then(() => {
            this.opinionDialog = false
            this.$message.success(this.shenpiStatus === 1 ? '审批通过' : '审批驳回')
            setTimeout(() => {
                window.close()
            }, 1500)
        }).catch((err: Error) => {

            this.disBtn = false
        })
    }

    /*
    * */
    confirmDialog() {
        // if (this.isRequired && this.shenpiStatus === 1) {
        //     for (let i = 0; i < this.editFileList.length; i++) {
        //         const item = this.editFileList[i]
        //         if (!this.editFiles[item.file] || this.editFiles[item.file].length === 0) {
        //             this.$message.error('请将信息填写完整')
        //             return
        //         }
        //     }
        // }
        const newObj: any = {}
        // this.editFileList.forEach(item => {
        //     newObj[item.file] = this.editFiles[item.file]
        // })
        // if('attendSchool' in newObj) {
        //     newObj['schoolId'] = this.editFiles.schoolId
        //
        // }
        const obj = {
            messageReviewId: this.id,
            status: this.shenpiStatus,
            opinion: this.opinion,
            form: this.shenpiStatus === 2 ? {} : newObj,
            nodeType: this.nodeType,
        }
        for (const key in obj) {
            if (!obj[key] || obj[key].length === 0) {
                delete obj[key]
            }
        }
        this.disBtn = true
        setMessageReviewUserByMessageReviewId(obj).then(() => {
            this.opinionDialog = false
            this.$message.success(this.shenpiStatus === 1 ? '审批通过' : '审批驳回')
            setTimeout(() => {
                window.close()
            }, 1500)
        }).catch((err: Error) => {
            // console.log(err)
            this.disBtn = false
        })
    }


    confirm() {
        this.shenpiStatus = 1
        this.approvedVisible = true
    }
    reject() {
        this.shenpiStatus = 2
        this.opinionDialog = true
    }
}
